import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Table } from 'react-bootstrap';
import moment from 'moment';

export const CashFlowReport = ({ cashFlow, startDate, endDate, activeProject, accounts, formatCurrency }) => {
  const getCleanName = (name) => {
    return name.replace(/^[\s\u00A0]+/, '').replace(/^\d+\s*·\s*/, '');
  };

  const renderDetailRows = (detailsObj, variant = 'text-dark') => {
    return Object.entries(detailsObj || {}).map(([name, amount]) => {
      const clean = getCleanName(name);
      const targetAcc = accounts.find(a => a.name === clean);
      return (
        <tr key={name} className="extra-small">
          <td className="pl-4 text-muted">
            {targetAcc ? (
              <Link to={`/accounts/${targetAcc._id}/transactions`} className="text-decoration-none text-muted font-weight-bold" style={{ cursor: 'pointer' }}>
                {name}
              </Link>
            ) : (
              name
            )}
          </td>
          <td className={`text-right ${variant}`}>
            {targetAcc ? (
              <Link to={`/accounts/${targetAcc._id}/transactions`} className="text-decoration-none text-muted font-weight-bold" style={{ cursor: 'pointer' }}>
                {formatCurrency(amount)}
              </Link>
            ) : (
              formatCurrency(amount)
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <Card className="border-0 shadow-sm">
      <Card.Body className="p-4">
        <div className="text-center mb-4">
          <h4 className="mb-1">Statement of Cash Flows</h4>
          <div className="text-muted small">{activeProject.name}</div>
          <div className="text-muted extra-small">For the period from {moment(startDate).format('MM/DD/YYYY')} to {moment(endDate).format('MM/DD/YYYY')}</div>
        </div>

        <Table responsive borderless className="report-table">
          <tbody>
            <tr className="bg-light font-weight-bold"><td>OPERATING ACTIVITIES</td><td className="text-right">{formatCurrency(cashFlow.operating.total)}</td></tr>
            {renderDetailRows(cashFlow.operating.details)}

            <tr className="bg-light font-weight-bold"><td>INVESTING ACTIVITIES</td><td className="text-right">{formatCurrency(cashFlow.investing.total)}</td></tr>
            {renderDetailRows(cashFlow.investing.details)}

            <tr className="bg-light font-weight-bold"><td>FINANCING ACTIVITIES</td><td className="text-right">{formatCurrency(cashFlow.financing.total)}</td></tr>
            {renderDetailRows(cashFlow.financing.details)}

            <tr className={`h4 font-weight-bold ${cashFlow.netChange >= 0 ? 'bg-success text-white' : 'bg-danger text-white'}`}>
              <td>NET CHANGE IN CASH</td>
              <td className="text-right">{formatCurrency(cashFlow.netChange)}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};
